import type { Feature } from './ConfigFeatures';

class Features {
  private readonly appFeatures: Record<string, Feature>;

  constructor(appFeatures: Record<string, Feature>) {
    this.appFeatures = appFeatures;
  }

  isActive = (feature: string | Feature) => {
    const featureKey = typeof feature === 'string' ? feature : feature?.key;
    const savedFeatures = this.getSavedFeatures();
    return savedFeatures?.[featureKey] ?? Boolean(this.appFeatures?.[featureKey]?.defVal);
  };

  private readonly getSavedFeatures = () =>
    typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('features') ?? '{}') : {};

  setActive = (feature: string | Feature, active: boolean) => {
    const featureKey = typeof feature === 'string' ? feature : feature.key;
    if (featureKey === undefined || featureKey === null || active === undefined) return;
    this.saveFeatures({ [featureKey]: active });
  };

  saveFeatures = (features: Record<string, boolean>) => {
    const savedFeatures = this.getSavedFeatures();
    localStorage.setItem('features', JSON.stringify({ ...savedFeatures, ...features }));
  };

  getFormattedFeatures = () =>
    Object.fromEntries(Object.entries(this.appFeatures).map(([featureKey, feature]) => [featureKey, this.isActive(feature)]));
}

export default Features;
